import { render, staticRenderFns } from "./AskMain.vue?vue&type=template&id=426aa47c&scoped=true&"
import script from "./AskMain.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMain.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMain.vue?vue&type=style&index=0&id=426aa47c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426aa47c",
  null
  
)

export default component.exports